import { createHook, createStore, type BoundActions, type HookFunction, type StoreActionApi } from 'react-sweet-state';

type State = {
	// We want `orgId` is always a string and empty value as default value. That helps to avoid dealing with null/undefined hassle.
	orgId: string;
};
type StoreApi = StoreActionApi<State>;

const actions = {
	// This action is used by EmbeddedDirectory to get Cloud Id in a remote store.
	setOrgId:
		(orgId: string) =>
		({ setState }: StoreApi): void => {
			setState({
				orgId,
			});
		},
};
type Actions = typeof actions;

const initialState: State = {
	orgId: '',
};

const Store = createStore<State, Actions>({
	initialState,
	actions,
	name: 'OrgStore',
});

export const useOrgIdState: HookFunction<State, BoundActions<State, {
    // This action is used by EmbeddedDirectory to get Cloud Id in a remote store.
    setOrgId: (orgId: string) => ({ setState }: StoreApi) => void;
}>, void> = createHook(Store);
